import { PostSubTypes } from "./../models/posts.model";
import { GeneralStockModel } from "../models/generalstock.model";
import PostsModel, { PostTypes } from "../models/posts.model";
import { StockTagModel } from "../models/stocks.model";
import utilService from "@/services/util.service";
import { popModal, pushModal } from "jenesius-vue-modal";
import { computed, Ref, ref } from "vue";
import { TYPE } from "vue-toastification";
import { EmojiClickEventDetail } from "vuemoji-picker";
import { usePosts } from "./posts.composables";
import { useUserInterface } from "./userinterface.composable";
import CreatePostFeelingComponent from "../components/add-post/CreatePostFeelingComponent.vue";
import { useRoute } from "vue-router";
import storageService from "@/services/storage.service";
import router from "@/router/router";
import httpService from "@/services/http.service";
import PostCardSnapImg from "../components/posts/PostCardSnapImg.vue";
import { useProfileScreenComposable } from "../../profile-screen/composables/profile.screen.composable";
import { useStockPost } from "@/composables/stockposts.composables";
import firebaseService from "@/services/firebase.service";
import { useI18n } from "vue-i18n";

const addPostModel = ref(new PostsModel());
const addPostModelFinalCall = ref(new PostsModel());
const repostId = ref<string>("");
let SelectedStock = ref<string[]>([]);
const domRect = ref();
const uploadingFilesLength = ref<number>(0);
const isMediaLoading = ref(false);
const postType = ref<string>("short");
const shareType = ref<string>("traderverse");
const sharePostOnTwitter = ref<boolean>(false);
const sharePostOnLinkedIn = ref<boolean>(false);
const ShowPagedDeleted = ref<boolean>(false);
const imagesPages = ref<Array<string>>([]);
const fileUploadLoader = ref(false);
const fromProfilePostCard = ref<any>();
const userInformation = ref<any>();
const stockInformation = ref<any>();
const createPotStockRes = ref<any>(null);
const feedSnap = ref("");
const user = ref();
const uploadCancelled = ref<boolean>(false);
const ongoingUploads = ref<Set<string>>(new Set());
const platforms = ref<any>([]);
export const useCreatePost = () => {
  const { profileData: user } = useProfileScreenComposable();
  const currentRoute = useRoute();
  const { addPost, getPostById } = usePosts();
  const { addPostToFeeding } = useStockPost();
  const { checkIfTagExist, getTextarea, convertTagToAnchor } =
    useUserInterface();
  const isAddMediaModalShown = ref<Boolean>(false);
  const selectedTab = ref<string>(PostTypes.text);
  const isEmojiPickerShown = ref<Boolean>(false);
  const richTextEditorConfig = ref<any>({
    placeholder: "Share something about the market.",
  });
  const isLoading = ref<boolean>(false);
  const file: Ref<File | null> = ref(null);
  const isFlipped = ref(false);
  const { getMyPosts, currentUser, temPostEding, myPosts } = usePosts();
  const { getPosts } = useStockPost();

  const { t } = useI18n();

  const initialData = () => {
    addPostModel.value.type = PostTypes.text;
  };

  const showEmptyError = (error = t('common.error.allMandatoryFields')) => {
    utilService.showToast(error, TYPE.ERROR);
  };

  const isValidHTMLWithContent = (text: string) => {
    const div = document.createElement('div');
    div.innerHTML = text;

    // Check for text content
    const plainText = div.textContent
      .replace(/[\u00A0\s\n\r\t]+/g, '')
      .trim();

    // Check specifically for img tags (only allowed media element)
    const hasImg = div.querySelector('img');

    // Return true if there's either meaningful text content or img tags
    // Empty <br> tags or other empty HTML elements will be ignored
    return plainText.length > 0 || hasImg !== null;
  }

  const createPost = async (stock: any) => {
    stockInformation.value = stock;
    var currentUser = storageService.getUser();
    getTextarea("getValue", null, addPostModel.value, "createPostTextArea");
    if (addPostModel.value.postSubType == "quoted") {
      getTextarea("getValue", null, addPostModel.value, "createPostTextAreaTwo", "quotedText");
    }

    if (repostId.value) {
      addPostModel.value.type = PostTypes.repost;
      // Always repost the latest post (the one user clicked), not the original
      addPostModel.value.repostId = repostId.value;
    }
    addPostModel.value.suggestions = {};

    if (addPostModel.value.stockTags.length) {
      checkIfTagExist(
        "$",
        addPostModel.value.body!,
        addPostModel.value.stockTags,
        "symbol"
      );
    }
    if (addPostModel.value.userTags.length) {
      checkIfTagExist(
        "@",
        addPostModel.value.body!,
        addPostModel.value.userTags,
        "userName"
      );
    }
    if (addPostModel.value.type == PostTypes.charts) {
      if (addPostModel.value.chart?.type == "poll") {
        if (!addPostModel.value.pollStock.stock.length) {
          showEmptyError();
          return;
        }
      } else if (
        !addPostModel.value.chart?.data ||
        !addPostModel.value.chart?.data.length
      ) {
        showEmptyError();
        return;
      }
    }
    if (
      addPostModel.value.type == PostTypes.media &&
      !addPostModel.value.media?.length
    ) {
      showEmptyError();
      return;
    }
    if (
      addPostModel.value.type == PostTypes.watchList &&
      !addPostModel.value.watchList?.length ||
      addPostModel.value.watchList?.stocks?.length == 0
    ) {
      showEmptyError();
      return;
    }

    if (
      addPostModel.value.type == PostTypes.portfolio &&
      addPostModel.value.postSubType == "trade" &&
      !addPostModel.value.trade
    ) {
      showEmptyError();
      return;
    }
    if (
      addPostModel.value.type == PostTypes.text &&
      addPostModel.value.postSubType == "page" &&
      !addPostModel.value.pagePostData.length
    ) {
      showEmptyError();
      return;
    }
    else if (
      addPostModel.value.type == PostTypes.text &&
      addPostModel.value.postSubType != "quoted" &&
      addPostModel.value.postSubType != "page" &&
      !isValidHTMLWithContent(addPostModel.value.body!) &&
      addPostModel.value.media.length == 0
    ) {
      showEmptyError();
      return;
    }
    if (
      addPostModel.value.type == PostTypes.text &&
      addPostModel.value.postSubType == "short" &&
      addPostModel.value.body?.length > 63000 &&
      addPostModel.value.plainTextBody?.length > 63000
    ) {
      showEmptyError("Your post exceeds the maximum character limit of 63000 characters");
      return;
    }

    if (
      (addPostModel.value.postSubType == PostSubTypes.prediction ||
        addPostModel.value.postSubType == PostSubTypes.watchlist) &&
      !addPostModel.value.watchList?.length &&
      !addPostModel.value.watchList?.stocks?.length
    ) {
      showEmptyError();
      return;
    }
    if (
      addPostModel.value.type == PostTypes.analysis &&
      addPostModel.value.postSubType == PostSubTypes.signal &&
      !addPostModel.value.signal.stock
    ) {
      showEmptyError();
      return;
    }

    if (
      addPostModel.value.type == "analysis" &&
      addPostModel.value.postSubType == PostSubTypes.charts &&
      !addPostModel.value!.chart!.data.length
    ) {
      showEmptyError();
      return;
    }
    if (
      addPostModel.value.type == PostTypes.profile &&
      addPostModel.value?.relations &&
      !addPostModel.value?.relations?.length
    ) {
      showEmptyError();
      return;
    }
    if (
      addPostModel.value.postSubType == "highlights" &&
      !addPostModel.value.sectionData?.data?.length
    ) {
      showEmptyError();
      return;
    }

    if (
      addPostModel.value.type == PostTypes.profile &&
      addPostModel.value.postSubType == "relations" &&
      !addPostModel.value.relations
    ) {
      showEmptyError();
      return;
    }
    if (
      addPostModel.value.type == PostTypes.profile &&
      !addPostModel.value?.sectionData &&
      (addPostModel.value?.sectionData?.type == PostSubTypes.links ||
        addPostModel.value?.sectionData?.type == PostSubTypes.topStats ||
        addPostModel.value?.sectionData?.type ==
        PostSubTypes.favouriteInvestment ||
        addPostModel.value?.sectionData?.type == PostSubTypes.portfolio) &&
      !addPostModel.value?.sectionData.data.length
    ) {
      showEmptyError();
      return;
    }
    if (ShowPagedDeleted.value) {
      addPostModel.value.pagePostData = [];
    }

    if (
      addPostModel.value.pagePostData.length === 0 &&
      addPostModel.value.type == "text" &&
      addPostModel.value.postSubType == "page"
    ) {
      showEmptyError();
      return;
    }

    if (stock && stock.symbol) {
      if (stock.symbol != "") {
        if (
          addPostModel.value.stockTags.findIndex(
            (x) => x.symbol == stock.symbol
          ) == -1
        ) {
          addPostModel.value.stockTags.push(stock);
        }
        var anchorElem = `<a class="anchor_tag--cash" id="${stock.symbol
          }" href="/stock/${stock.symbol.substring(1)}">${stock.symbol
          }</a>&nbsp;`;
      }
    }
    isLoading.value = true;
    await setPostType();
    if (addPostModel.value.type == PostTypes.watchList) {
      await setDetailWatchlistBit();
    }
    if (sharePostOnLinkedIn.value || sharePostOnTwitter.value) {
      addPostModel.value.coverPhoto = user.value?.coverPhoto;
      addPostModel.value.modifiedOn = user.value?.createdOn;
      addPostModel.value.profilePicture = user.value?.profilePicture;
      addPostModel.value._id = currentUser._id;
      addPostModel.value.userName = user.value?.userName;
      addPostModel.value.fullName = user.value?.fullName;
      openSnapModal(addPostModel.value);
    } else {
      let newModel = JSON.parse(JSON.stringify(addPostModel.value));
      if (newModel.type === "analysis") {
        if (newModel.postSubType === "prediction") {
          newModel.prediction = newModel.watchList;
          newModel.watchList = [];
        }
      }
      if (newModel.type === "profile" && newModel.postSubType === "relations") {
        if (newModel.relations && newModel.relations.length > 0) {
          newModel.relations = newModel.relations.map(
            (relation) => relation._id
          );
        }
      }
      if (newModel.type === "analysis" && newModel.postSubType === "signal") {
        if (newModel.signal && newModel.signal.stock) {
          let stockSymbol = newModel.signal.stock.symbol;
          let stockId = newModel.signal.stock.stockId;
          let type = newModel.signal.stock.type;
          if (!newModel.stockTags) {
            newModel.stockTags = [];
          }
          let isStockPresent = newModel.stockTags.some(
            (stock) => stock.symbol === stockSymbol
          );
          if (!isStockPresent) {
            newModel.stockTags.push({
              stockId: stockId,
              symbol: "$" + stockSymbol,
              market: type,
            });
          }
        }
      }
      if (newModel.type === "portfolio" && newModel.postSubType === "trade") {
        if (newModel.trade) {
          let stockSymbol = newModel.trade[0].symbol;
          let stockId = newModel.trade[0].stockId;
          let type = newModel.trade[0].stockType;
          let name = newModel.trade[0].name;
          if (!newModel.stockTags) {
            newModel.stockTags = [];
          }
          let isStockPresent = newModel.stockTags.some(
            (stock) => stock.symbol === stockSymbol
          );
          if (!isStockPresent) {
            newModel.stockTags.push({
              stockId: stockId,
              symbol: "$" + stockSymbol,
              market: type,
              name: name
            });
          }
        }
      }
      if (
        newModel.type === "analysis" &&
        newModel.postSubType === "watchlist"
      ) {
        if (!newModel.stockTags) {
          newModel.stockTags = [];
        }
        if (newModel.watchList && Array.isArray(newModel.watchList)) {
          newModel.watchList.forEach((stock) => {
            let isStockPresent = newModel.stockTags.some(
              (tag) => tag.stockId === stock._id
            );
            if (!isStockPresent) {
              newModel.stockTags.push({
                stockId: stock.stockId || stock._id,
                symbol: "$" + stock.symbol,
                market: stock.market || "stocks",
              });
            }
          });
        }
      }
      if (
        newModel.type === "analysis" &&
        newModel.postSubType === "prediction"
      ) {
        if (!newModel.stockTags) {
          newModel.stockTags = [];
        }
        if (newModel.prediction && Array.isArray(newModel.prediction)) {
          newModel.prediction.forEach((stock) => {
            let isStockPresent = newModel.stockTags.some(
              (tag) => tag.stockId === stock._id
            );
            if (!isStockPresent) {
              newModel.stockTags.push({
                stockId: stock.stockId || stock._id,
                symbol: "$" + stock.symbol,
                market: stock.market || "stocks",
              });
            }
          });
        }
      }
      if (newModel.type === "portfolio" && newModel.postSubType === "trade") {
        if (!newModel.stockTags) {
          newModel.stockTags = [];
        }
        if (newModel.trade && newModel.trade.symbol) {
          let isStockPresent = newModel.stockTags.some(
            (tag) => tag.stockId === newModel.trade.stockId
          );
          if (!isStockPresent) {
            newModel.stockTags.push({
              stockId: newModel.trade.stockId,
              symbol: "$" + newModel.trade.symbol,
              market: newModel.trade.stockType || "stocks",
            });
          }
        }
      }
      if (
        newModel.type === "profile" &&
        newModel.postSubType === "highlights"
      ) {
        if (newModel.sectionData?.name === "Favorite Investments") {
          if (!newModel.stockTags) {
            newModel.stockTags = [];
          }
          if (
            newModel.sectionData &&
            Array.isArray(newModel.sectionData.data)
          ) {
            newModel.sectionData.data.forEach((stock) => {
              let isStockPresent = newModel.stockTags.some(
                (tag) => tag.stockId === stock.stockId
              );
              if (!isStockPresent) {
                newModel.stockTags.push({
                  stockId: stock.stockId,
                  symbol: "$" + stock.symbol,
                  market: stock.type || "stocks",
                });
              }
            });
          }
        }
      }
      if (newModel.type === "analysis" && newModel.postSubType === "charts") {
        if (newModel.chart && newModel.chart.stocks) {
          let stockSymbol = newModel.chart.stocks.symbol;
          let stockId = newModel.chart.stocks.stockId;
          let type = newModel.chart.stocks.type;
          if (!newModel.stockTags) {
            newModel.stockTags = [];
          }
          let isStockPresent = newModel.stockTags.some(
            (stock) => stock.symbol === stockSymbol
          );
          if (!isStockPresent) {
            newModel.stockTags.push({
              stockId: stockId,
              symbol: "$" + stockSymbol,
              market: type,
            });
          }
        }
      }
      if (
        newModel.type === "analysis" &&
        newModel.postSubType === "watchlist"
      ) {
        newModel.watchList = {};
        let obj = {
          name: new Date().toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "long",
            year: "numeric",
          }),
          tagColor: "#0D0D0D",
          stocks: addPostModel.value.watchList,
          isActive: true,
        };
        newModel.watchList = obj;
        delete newModel.tempWatchlistStock;
      }
      if (newModel.type === "profile" && newModel.postSubType === "short") {
        newModel.postSubType = "highlights";
      }

      if (newModel.metaData && newModel.metaData.length > 1) {
        newModel.metaData = newModel.metaData.filter((item: any, index: any, self: any) =>
          index === self.findIndex(obj => obj["al:android:app_name"] === item["al:android:app_name"])
        );
      }
      if (window.location.pathname.includes("stock") || window.location.pathname.includes("crypto")) {
        newModel.postPrivacy = newModel.postPrivacy.toLowerCase();
        addPostToFeeding(newModel)
          .then((res: any) => {
            if (!res) {
              utilService.showToast(
                "There is something wrong, please try again!",
                TYPE.ERROR
              );
              isLoading.value = false;
              return
            }
            postType.value = "short";
            selectedTab.value = "text";
            discardPost(stock!);
            imagesPages.value = [];
            if (fromProfilePostCard.value) {
              if (user.value) {
                getMyPosts(user.value!._id!, 1);
              }
            } else {
              if (window.location.pathname.includes("stock") || window.location.pathname.includes("crypto")) {
                getPosts(stock.symbol, 1);
                popModal();
              } else if (currentRoute.name != "feed") {
                router.push({ name: "feed" });
              }
            }

            popModal();
            isLoading.value = false;
          })
          .catch((e: any) => {
            utilService.showToast(
              t('common.error.allMandatoryFields'),
              TYPE.ERROR
            );
            isLoading.value = false;
          });
      } else {
        newModel.postPrivacy = newModel.postPrivacy.toLowerCase();
        if (platforms.value && platforms.value.length > 0) {
          newModel.platforms = platforms.value;
        }
        addPost(newModel)
          .then((res: any) => {
            if (!res) {
              utilService.showToast(
                "There is something wrong, please try again!",
                TYPE.ERROR
              );
              isLoading.value = false;
              return
            }
            postType.value = "short";
            selectedTab.value = "text";
            discardPost(stock!);
            imagesPages.value = [];
            platforms.value = [];
            if (fromProfilePostCard.value) {
              if (user.value) {
                getMyPosts(user.value!._id!, 1);
              }
            } else {
              if (window.location.pathname.includes("stock") || window.location.pathname.includes("crypto")) {
                getPosts(stock.symbol, 1);
                popModal();
              } else if (currentRoute.name != "feed") {
                router.push({ name: "feed" });
              }
            }

            popModal();
            isLoading.value = false;
          })
          .catch((e: any) => {
            utilService.showToast(
              t('common.error.allMandatoryFields'),
              TYPE.ERROR
            );
            isLoading.value = false;
          });
      }
    }
  };

  const addPostAfterSnap = () => {
    isLoading.value = true;
    addPostModel.value.postOnLinkedin = sharePostOnLinkedIn.value;
    addPostModel.value.postOnTwitter = sharePostOnTwitter.value;
    addPostModel.value.postUrl = feedSnap.value;
    addPost(addPostModel.value)
      .then((res: any) => {
        postType.value = "short";
        selectedTab.value = "text";
        discardPost(createPotStockRes.value!);
        imagesPages.value = [];
        if (fromProfilePostCard.value) {
          if (user.value) {
            getMyPosts(user.value!._id!, 1);
            popModal();
          }
        } else {
          if (window.location.pathname.includes("stock")) {
            getPosts(stockInformation.value.symbol, 1);
            popModal();
          } else if (currentRoute.name != "feed") {
            router.push({ name: "feed" });
          }
        }
        popModal();
        isLoading.value = false;
      })
      .catch((e: any) => {
        utilService.showToast("Error! Adding Post", TYPE.ERROR);
        isLoading.value = false;
      });
  };

  const openSnapModal = async (data: any) => {
    const modal = await pushModal(PostCardSnapImg, { post: data });
    modal.on("close", (data: any) => { });
  };

  const setDetailWatchlistBit = async () => {
    return new Promise((resolve, reject) => {
      try {
        for (let watchlist of addPostModel.value.watchList!) {
          watchlist.isDetailWatchlist = watchlist.description!.length > 0;
        }
        resolve(true);
      } catch (e) {
        reject(e);
      }
    });
  };

  const setPostType = async () => {
    return new Promise((resolve, reject) => {
      try {
        addPostModel.value.postSubType = postType.value;
        if (addPostModel.value.type == PostTypes.watchList) {
          for (let watchlist of addPostModel.value.watchList!) {
            addStock(watchlist.symbol!, watchlist.market!);
          }
        } else if (addPostModel.value.type == PostTypes.charts) {
          if (addPostModel.value.chart?.type == "poll") {
            if (
              addPostModel.value.pollStock &&
              addPostModel.value.pollStock.stock &&
              addPostModel.value.pollStock.stock.length
            ) {
              for (let stock of addPostModel.value.pollStock.stock) {
                addStock(stock.symbol, stock.type);
              }
            }
          } else {
            addStock(
              addPostModel.value.chart!.stocks?.symbol!,
              addPostModel.value.chart!.stocks?.type!
            );
          }
        }
        for (let stock of addPostModel.value.stockTags) {
          addStock(stock.symbol, stock.market);
        }
        if (
          addPostModel.value.portfolio &&
          addPostModel.value.portfolio.lineItems
        ) {
          for (let stock of addPostModel.value.portfolio?.lineItems) {
            addStock(stock.ticker, stock.stockType!);
          }
        }
        resolve(true);
      } catch (e) {
        reject(e);
      }
    });
  };

  const addStock = (symbol: string, market: string) => {
    if (!addPostModel.value.markets.includes(market)) {
      addPostModel.value.markets.push(market);
    }
    let indexOfStock = addPostModel.value.stockTags.findIndex(
      (x) => x.symbol == symbol && x.market == market
    );
    if (indexOfStock == -1) {
      if (symbol[0] != "$") {
        symbol = `\$${symbol}`;
      }
      addPostModel.value.stockTags.push(new StockTagModel(symbol, market));
    }
  };

  const discardPost = (stockTag: StockTagModel | null) => {
    uploadCancelled.value = true;
    platforms.value = [];
    uploadingFilesLength.value = 0;
    isMediaLoading.value = false;
    ongoingUploads.value.clear();

    addPostModel.value = new PostsModel();
    addPostModel.value.media = [];
    selectedTab.value = "text";
    postType.value = "short";
    repostId.value = "";
    getTextarea("clear", null, addPostModel.value, "createPostTextArea");
    firebaseService.cancelUpload();

    setTimeout(() => {
      uploadCancelled.value = false;
    }, 100);
  };

  const addStockTag = (stock: StockTagModel) => {
    addPostModel.value.stockTags.push(stock);
    convertTagToAnchor("$", stock.symbol.substring(1), "createPostTextArea", stock.market, stock.stockId);
  };

  const clearRichTextEditor = () => {
    var elem = document.getElementsByClassName("ql-editor");
    if (elem && elem.length) {
      elem[0].innerHTML = "";
    }
  };

  const toggleAddMediaModal = (isOpen: boolean, value: any = null) => {
    isAddMediaModalShown.value = isOpen;
    if (value != null) {
      addPostModel.value.media = [];
      addPostModel.value.media = [...value.value];
    }
  };

  const selectTab = (val: string) => {
    if (val != selectedTab.value) {
      addPostModel.value.suggestions = [];
      addPostModel.value.type = val;
      addPostModel.value.watchlistCategory = "";
      addPostModel.value.portfolio = undefined;
      selectedTab.value = val;
      if (val != PostTypes.text) {
        addPostModel.value.quotedImage = 0;
        postType.value = "short";
      }
      if (val == "media") {
        postType.value = "media";
      } else if (val == "watchList") {
        postType.value = "regularWatchlist";
      } else if (val == "text") {
        postType.value = "short";
      } else if (val == "charts") {
        postType.value = "price";
      } else if (val == "portfolio") {
        postType.value = "trade";
      } else if (val == "profile") {
        postType.value = "highlights";
      } else if (val === "analysis") {
        postType.value = "signal";
      }
    }
  };

  const selectEmoji = (detail: EmojiClickEventDetail) => {
    if (addPostModel.value.postSubType == "quoted") {
      getTextarea(
        "append",
        detail.unicode,
        addPostModel.value,
        "createPostTextAreaTwo"
      );
    } else {
      getTextarea(
        "append",
        detail.unicode,
        addPostModel.value,
        "createPostTextArea"
      );
    }
  };

  const toggleEmojiPicker = (val: boolean | null) => {
    if (typeof val != "boolean") {
      isEmojiPickerShown.value = !isEmojiPickerShown.value;
    } else {
      isEmojiPickerShown.value = val;
    }
  };

  const onPostTypeChanged = (val: string) => {
    getTextarea("getValue", null, addPostModel.value, "createPostTextArea");
    postType.value = val;
    addPostModel.value.postSubType = postType.value;
    if (addPostModel.value.type == PostTypes.media) {
      addPostModel.value.media = [];
    }
    if (addPostModel.value.type == PostTypes.watchList) {
      addPostModel.value.watchList = [];
      addPostModel.value.watchlistCategory = "";
    }
    if (addPostModel.value.type == PostTypes.analysis) {
    }
    if (val == "quoted") {
      if (!addPostModel.value.quotedImage) {
        addPostModel.value.quotedImage = 1;
      }
    } else {
      addPostModel.value.quotedImage = undefined;
    }
  };

  const addWatchListToPost = (list: any[]) => {
    if (!addPostModel.value.watchList) {
      addPostModel.value.watchList = [];
    }
    addPostModel.value.watchList = list.map((x) => {
      var watchList = GeneralStockModel.getWatchlist(x);
      watchList.market = x.type;
      watchList.type = x.type;
      watchList.name = x.companyName;
      watchList.companyName = x.companyName;
      if (postType.value == "prediction") {
        watchList.watchlistType =
          addPostModel.value.type == PostTypes.text
            ? `text-prediction`
            : `watchlist-prediction`;
      }
      return watchList;
    });
  };

  const addWatchListPredicitonToPost = (list: any[]) => {
    if (!addPostModel.value.watchList) {
      addPostModel.value.watchList = [];
    }
    addPostModel.value.watchList = list.map((x: any) => {
      var watchList = x;
      if (postType.value == "prediction") {
        watchList.watchlistType =
          addPostModel.value.type == PostTypes.text
            ? `text-prediction`
            : `watchlist-prediction`;
      }
      return watchList;
    });
  };

  const setDomRect = () => {
    const selection = window.getSelection();
    const range = selection?.rangeCount ? selection.getRangeAt(0) : null;
    let rect = range?.getClientRects()?.[0];
    if (!rect) {
      const el = getTextareaElement();
      rect = el?.getBoundingClientRect();
    }

    if (rect) {
      domRect.value = rect;
    }
  };


  const getTextareaElement = () => {
    let el = document.querySelector(".createPostTextArea") as HTMLInputElement;
    if (addPostModel.value.postSubType == "quoted") {
      el = document.querySelector(".createPostTextAreaTwo") as HTMLInputElement;
    }
    return el;
  }

  const getSuggestionStyle = computed(() => {
    if (!domRect.value) {
      isFlipped.value = false;
      return {
        top: "200px",
        left: "40px",
      };
    }

    const dropdownWidth = 200;
    const viewportWidth = window.innerWidth;
    const spaceRight = viewportWidth - domRect.value.left;

    if (spaceRight < dropdownWidth) {
      isFlipped.value = true;
      return {
        top: domRect.value.top + (domRect.value.height || 20) + "px",
        left: domRect.value.left - dropdownWidth + "px",
      };
    } else {
      isFlipped.value = false;
      return {
        top: domRect.value.top + (domRect.value.height || 20) + "px",
        left: domRect.value.left + "px",
      };
    }
  });

  const uploadPdfPages = async (file: any) => {
    try {
      fileUploadLoader.value = true;
      const formData = new FormData();
      formData.append("file", file?.target?.files[0]);
      const response = await httpService.uploadPdf(formData);
      imagesPages.value = response?.data?.data;
      ShowPagedDeleted.value = false;
    } catch (error) {
    } finally {
      fileUploadLoader.value = false;
    }
  };

  const uploadOnServer = async (files: any, type: string, addPostModelToUpdate: any, emitCallback?: (event: string, value: boolean) => void) => {
    isMediaLoading.value = true;
    emitCallback?.("update:isMediaUploading", true);

    for (let i = 0; i < files.length; i++) {
      if (uploadCancelled.value) {
        break;
      }

      const uploadId = `upload_${Date.now()}_${i}`;
      ongoingUploads.value.add(uploadId);

      try {
        if (files[i].type.includes("video")) {
          addPostModelToUpdate.media = [];
        }

        let result = await firebaseService.uploadMedia(files[i]);

        if (!uploadCancelled.value) {
          let data = {
            _id: new Date().toString(),
            type: files[i].type,
            url: result,
          };
          if (addPostModelToUpdate.media === undefined) {
            addPostModelToUpdate.media = [];
          }
          addPostModelToUpdate.media!.push(data);
        }

        uploadingFilesLength.value--;
        ongoingUploads.value.delete(uploadId);

        if (/^video\//.test(files[i].type) || /^audio\//.test(files[i].type)) {
          break;
        }
      } catch (error) {
        ongoingUploads.value.delete(uploadId);
        uploadingFilesLength.value--;
      }
    }

    if (!uploadCancelled.value) {
      isMediaLoading.value = false;
      emitCallback?.("update:isMediaUploading", false);
    } else {
      uploadingFilesLength.value = 0;
      isMediaLoading.value = false;
      emitCallback?.("update:isMediaUploading", false);
      addPostModelToUpdate.media = [];
    }
  };

  const checkMediaType = (files: any, type: string) => {
    return new Promise((resolve, reject) => {
      try {
        let isValid = false;
        for (let file of files) {
          if (type == "media") {
            isValid =
              file.type.includes("video") ||
              file.type.includes("image") ||
              file.type.includes("text/plain") ||
              file.type.includes("application/pdf") ||
              file.type.includes("application/msword") ||
              file.type.includes("application/vnd.ms-excel") ||
              file.type.includes("application/vnd.ms-powerpoint");
          } else if (type == "audio") {
            isValid = file.type.includes("audio");
          }
        }
        resolve(isValid);
      } catch (e) {
        resolve(false);
      }
    });
  };

  return {
    ShowPagedDeleted,
    domRect,
    addPostModel,
    SelectedStock,
    isLoading,
    isAddMediaModalShown,
    selectedTab,
    richTextEditorConfig,
    postType,
    addWatchListPredicitonToPost,
    isEmojiPickerShown,
    repostId,
    getSuggestionStyle,
    isFlipped,
    uploadingFilesLength,
    isMediaLoading,
    file,
    fileUploadLoader,
    initialData,
    setDomRect,
    addStockTag,
    createPost,
    discardPost,
    toggleAddMediaModal,
    userInformation,
    selectTab,
    selectEmoji,
    onPostTypeChanged,
    toggleEmojiPicker,
    addWatchListToPost,
    fromProfilePostCard,
    uploadPdfPages,
    user,
    platforms,
    imagesPages,
    shareType,
    feedSnap,
    sharePostOnTwitter,
    sharePostOnLinkedIn,
    addPostAfterSnap,
    createPotStockRes,
    uploadCancelled,
    ongoingUploads,
    uploadOnServer,
    checkMediaType,
  };

};
